<!-- [translate]="'communication.emailPreview'" -->
<div flex layout-align="space-between center" layout="row">
  <div
    class="modal-dialog-title"
    flex
    >
    {{'clientRelations.company.companyPhonesTitle' |translate: { EIK:data.identifier } }}
  </div>

  <button
    tabindex="-1"
    mat-icon-button
    (click)="updatePhones()"
    [disabled]="disableSearch"
    matTooltip="{{'clientRelations.company.initiateSearch' | translate}}"
    >

    <mat-icon>refresh</mat-icon>
  </button>

  <button
    tabindex="-1"
    mat-icon-button
    (click)="close()"
    >
    <mat-icon>clear</mat-icon>
  </button>
</div>
<div class="margin-top">
  @if (companyPhones[0]?.phone) {
    @for (phone of companyPhones; track phone) {
      <itfg-single-company-phone
        [data] = phone
        [disableAddToContacts] = isExisting(phone.phone)
        (addToContacts)="addToContacts($event)"
        >
      </itfg-single-company-phone>
    }
  } @else {
    <div layout="column" flex layout-align="center center">
      @if (companyPhones[0]) {
        {{'clientRelations.company.noResultsFound' | translate}}
      }
      @if (!companyPhones[0]) {
        {{'clientRelations.company.noSearchBatch' | translate}}
        <button
          tabindex="-1"
          mat-raised-button
          (click)="updatePhones()"
          [disabled]="disableSearch"
          class="margin-top"
          >
          {{'clientRelations.company.initiateSearch' | translate}}
        </button>
      }
    </div>
  }
</div>

